fragment AddressFields on AddressNode {
  id
  buildingNumber
  buildingName
  street
  city
  postcode
  what3words
  latitude
  longitude
}
